import * as React from "react";

interface IPdfSvgProps {
	width: string;
	height: string;
	viewbox: string;
}

export function PdfSvg(props: IPdfSvgProps): JSX.Element {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox={props.viewbox}>
			<defs>
				<style>
					{`.cls-1{fill:#fff}.cls-1,.cls-2{stroke:#ccc}.cls-1{stroke-linecap:round;stroke-linejoin:round}.cls-2,.cls-7{fill:none}.cls-2{stroke-miterlimit:10}.cls-6{stroke:none}`}
				</style>
			</defs>
			<g id="Component_9_1" transform="translate(0 .5)">
				<path id="Path_1414" d="M10.586-255H-17.5v59.5h42.586v-45h-14.5z" className="cls-1" transform="translate(26 255)" />
				<path id="Path_1415" d="M25.086-240.5l-14.5-14.5v14.5z" className="cls-1" transform="translate(26 255)" />
				<g id="Rectangle_1066" className="cls-2">
					<path d="M0 0H16.293V5.5H0z" className="cls-6" transform="translate(21.646 25)" />
					<path d="M0.5 0.5H15.793V5H0.5z" className="cls-7" transform="translate(21.646 25)" />
				</g>
				<g id="Rectangle_1067" className="cls-2">
					<path d="M0 0H6.354V5.5H0z" className="cls-6" transform="translate(21.646 32)" />
					<path d="M0.5 0.5H5.854V5H0.5z" className="cls-7" transform="translate(21.646 32)" />
				</g>
				<g id="Rectangle_1068" className="cls-2">
					<path d="M0 0H6.354V5.5H0z" className="cls-6" transform="translate(29.646 32)" />
					<path d="M0.5 0.5H5.854V5H0.5z" className="cls-7" transform="translate(29.646 32)" />
				</g>
				<path id="Rectangle_1069" fill="#ccc" d="M0 0H12V1H0z" transform="translate(21.646 40)" />
				<rect id="Rectangle_1070" width="31" height="16" fill="#0663e2" rx="1.505" transform="translate(0 50)" />
				<text id="PDF" fill="#fff" fontFamily="RobotoBold, Roboto" fontSize="9px" fontWeight="700" transform="translate(6 53)">
					<tspan y="8">
						PDF
					</tspan>
				</text>
			</g>
		</svg>
	);
}
export default PdfSvg;
